module.exports = __webpack_public_path__ + "img/mendian.03a81a87.png";